(function() {
  'use strict';

  const STORAGE_KEY = 'qf_utm';
  const UTM_KEYS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content'
  ];

  // Matches ASCII control characters; written as escapes so no raw control
  // bytes end up in this source file.
  const CONTROL_CHARS = new RegExp('[\u0000-\u001F\u007F]', 'g');

  function logDebug(message, data) {
    if (!window.qfUtmDebug) {
      return;
    }
    if (data) {
      console.log(message, data);
      return;
    }
    console.log(message);
  }

  // Values arrive from an untrusted query string and end up in a submitted
  // payload, so strip control characters and cap the length.
  function clean(value) {
    if (value === null || value === undefined) {
      return '';
    }
    return String(value)
      .replace(CONTROL_CHARS, '')
      .trim()
      .slice(0, 255);
  }

  function readStore() {
    try {
      const raw = window.sessionStorage.getItem(STORAGE_KEY);
      if (raw) {
        return JSON.parse(raw) || {};
      }
    } catch (error) {
      // sessionStorage throws in Safari private mode and partitioned contexts.
    }
    return window.qfUtmMemory || {};
  }

  function writeStore(data) {
    // Always keep an in-memory mirror so attribution survives a storage failure.
    window.qfUtmMemory = data;
    try {
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (error) {
      // noop
    }
  }

  function capture() {
    let params;
    try {
      params = new URLSearchParams(window.location.search);
    } catch (error) {
      return readStore();
    }

    const fresh = {};
    let tagged = false;

    UTM_KEYS.forEach(function(key) {
      const value = clean(params.get(key));
      if (value) {
        fresh[key] = value;
        tagged = true;
      }
    });

    // A newly tagged landing replaces the session wholesale, so a visitor who
    // arrives from two campaigns is attributed to the one they converted on.
    if (tagged) {
      fresh.landing_page = clean(window.location.pathname + window.location.search);
      fresh.landing_referrer = clean(document.referrer);
      writeStore(fresh);
      logDebug('[qf-utm] captured', fresh);
      return fresh;
    }

    const stored = readStore();
    logDebug('[qf-utm] restored', stored);
    return stored;
  }

  // Run immediately rather than on DOMContentLoaded, so the parameters are
  // banked before anything can rewrite the URL.
  const attribution = capture();

  window.qfUtm = {
    keys: UTM_KEYS,

    all: function() {
      return Object.assign({}, attribution);
    },

    get: function(key) {
      return attribution[key] || '';
    },

    // Fills any <input data-utm-field="utm_source"> within scope.
    hydrate: function(scope) {
      const root = scope || document;
      const inputs = root.querySelectorAll('[data-utm-field]');
      Array.prototype.forEach.call(inputs, function(input) {
        const key = input.getAttribute('data-utm-field');
        input.value = attribution[key] || '';
      });
      return inputs.length;
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      window.qfUtm.hydrate();
    });
  } else {
    window.qfUtm.hydrate();
  }
})();
